export class EmailRequiredError extends Error {
  constructor() {
    super('E-mail é obrigatório')
    this.name = 'EmailRequiredError'
  }
}
